import { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Loader: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">{t('Loading...')}</span>
      </Spinner>
    </div>
  );
};

export default Loader;